import './controllers/generalCtrl';
import './controllers/tabsController';
import './controllers/serviceContent/index';
import './controllers/directives';
import './controllers/factories';
import './validators/emailConfirmed';
import './validators/userProcess';
import './controllers/offers/index';
import './controllers/userOfficeController';
import './controllers/reportChartsCtrl';

import './controllers/partner/index';
import './controllers/user/index';
import './controllers/singleApplication/index';
import './controllers/finHealth/finHealthCtrl';
import './controllers/bikfish/index';
import './controllers/blog/index';

import './controllers/forms/index'

import './controllers/main/index'
import './controllers/udostepnij/index'
import './libs/sliderCnf';




// WEBPACK FOOTER //
// src/js/main.js